import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../customers/forms/ShippingAddressForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelEditShippingAddress} from "../../actions/CheckoutApiActions";
import {fromJS, List} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {validateForm} from "../../lib/ShippingAddressValidation";
import {getUSStates, getCanadaProvinces, isUS, isCanada} from "../../lib/CountriesAndStates";
import {hasStateProvince} from "../../lib/AddressRules";
import {getCompletePhoneNrOrNothing} from "../../lib/TelephoneNormalizer";

class EditShippingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("orderId", this.props.orderId)
                              .set("accountId", this.props.accountId)
                              .set("phoneNr", getCompletePhoneNrOrNothing(values.get("phoneNr")));

    return this.props.assignShippingAddress(updatedValues.toJS())
      .then((response) => {
        if (response.data.assignShippingAddress.errors.length <= 0) {
          this.props.cancelEditShippingAddress();
        } else {
          let errors = createValidationErrors(response.data.assignShippingAddress.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelEditShippingAddress();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let countries = fromJS(data.availableCountriesForAccount);
    let orderInfo = fromJS(data.salesOrder);
    let initialValues = orderInfo.get("shippingAddress").delete("__typename");
    let stateProvinces = List([]);
    if (this.props.showUSStates) stateProvinces = getUSStates();
    if (this.props.showCanadaProvinces) stateProvinces = getCanadaProvinces();

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        countries={countries}
        stateProvinces={stateProvinces}
        showAttentionName={true}
        showPhoneNr={true}
        showEmail={true}
        showStateProvince={this.props.showStateProvince}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

EditShippingAddressFormContainer.defaultProps = {
  defaultCountryDialCode: "+1"
}

const ASSIGN_SHIPPING_ADDRESS = gql`
  mutation assignShippingAddress($data: SalesOrderShippingAddressInput!) {
    assignShippingAddress(input: $data) {
      errors { key message }
    }
  }
`;

const SHIPPING_COUNTRIES_FOR_ACCOUNT = gql`
  query availableCountriesForAccount($accountId:ID!, $orderId:ID!) {
    availableCountriesForAccount(accountId:$accountId) {
      kind
      code
      name
      availability
    },
    salesOrder(orderId:$orderId) {
      shippingAddress {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressStateProvince
        addressPostcode
        addressCountryCode   
      }
    }
  }
`;

const withAddressQuery = compose(
  graphql(SHIPPING_COUNTRIES_FOR_ACCOUNT, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId,
        orderId: props.orderId
      }
    })
  }),
  graphql(ASSIGN_SHIPPING_ADDRESS, {
    props: ({ mutate }) => ({
      assignShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const EditShippingAddressFormContainerWithData = withAddressQuery(EditShippingAddressFormContainer);

const selector = formValueSelector("ShippingAddressForm");
function mapStateToProps(state, ownProps) {
  return {
    showUSStates: isUS(selector(state, "addressCountryCode")),
    showCanadaProvinces: isCanada(selector(state, "addressCountryCode")),
    showStateProvince: hasStateProvince(selector(state, "addressCountryCode"))
  }
}

export default connect(mapStateToProps, {cancelEditShippingAddress})(EditShippingAddressFormContainerWithData);